<template>
  <div ref="submenuContainer" class="second-level-menu" data-lenis-prevent>
    <div class="first-container">
      <button @click="goBack" class="go-back-button text-medium">
        <!--
        <img
          src="@/assets/img/ico/arrow-mobile.svg?url"
          class="icon-arrow-back"
        />
        -->
        <ArrowIcon alt="Arrow icon" class="icon-arrow-back" />

        <span v-html="$t('common.indietro')" />
      </button>
      <div class="submenu-links menu-text">
        <div class="mobile-link first">
          <button class="accordion-element" @click="toggleAccordion">
            <span>{{
              props.navigation.globalSets[1].navigationPages[0].title
            }}</span>
            <ArrowDown
              alt="Arrow icon"
              class="accordion-icon"
              :class="{ open: isAccordionOpen }"
            />
          </button>
          <div ref="accordionContent" class="accordion-content">
            <NuxtLink
              v-for="(link, index) in filteredCategories"
              :key="index"
              :to="
                localePath({
                  name: 'vino-slug',
                  params: { slug: link.slug },
                })
              "
              class="categoria"
            >
              <span class="text-big">{{ link.title }}</span>
            </NuxtLink>
            <NuxtLink :to="localePath({ name: 'vino' })">
              <div class="text-base default-icon-btn is-purple">
                <span v-html="$t('common.seeAll')" />
                <ArrowIcon alt="Arrow icon" class="icon-arrow" />
              </div>
            </NuxtLink>
          </div>
        </div>
        <div>
          <NuxtLink
            v-for="(
              link, index
            ) in props.navigation.globalSets[1].navigationPages.slice(1)"
            :key="index"
            class="mobile-link"
            :to="localePath(link.key)"
          >
            {{ link.title }}
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="second-container">
      <div class="content">
        <p class="text-medium title" v-html="$t('navigation.comeFarePer')" />
        <div class="links-container">
          <NuxtLink
            v-for="(link, index) in props.navigation.comeFarePerEntries"
            :key="index"
            class="text-medium"
            :to="
              localePath({
                name: 'come-fare-per-slug',
                params: { slug: link.slug },
              })
            "
          >
            {{ link.title }}
          </NuxtLink>
        </div>
        <NuxtLink :to="localePath({ name: 'risorse' })">
          <div class="text-base default-icon-btn is-purple">
            <span v-html="$t('common.seeAll')" />
            <img
              alt="Arrow icon"
              src="@/assets/img/ico/arrow-purple.svg?url"
              class="icon-arrow"
            />
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'
import ArrowDown from '@/assets/img/ico/arrow-down.svg'
import { gsap } from 'gsap'

const props = defineProps({
  isFullOverlayOpen: Boolean,
  navigation: Object,
})

const submenuContainer = ref(null)
const isAccordionOpen = ref(false)
const accordionContent = ref(null)

const emit = defineEmits(['goBack', 'toggleAccordion'])

const filteredCategories = computed(() => {
  return props.navigation.categories.filter((category) => {
    return category.slug && category.title
  })
})

const toggleAccordion = () => {
  isAccordionOpen.value = !isAccordionOpen.value
  if (isAccordionOpen.value) {
    const contentHeight = accordionContent.value.scrollHeight
    gsap.to(accordionContent.value, {
      height: contentHeight,
      margin: '20px 0 30px',
      duration: 1,
      ease: 'power2.out',
      onComplete: () => {
        gsap.set(accordionContent.value, { height: 'auto' })
      },
    })
  } else {
    gsap.to(accordionContent.value, {
      height: 0,
      margin: 0,
      duration: 1,
      ease: 'power2.inOut',
    })
  }
  emit('toggleAccordion', isAccordionOpen.value)
}

const goBack = () => {
  isAccordionOpen.value = false
  gsap.to(accordionContent.value, {
    height: 0,
    margin: 0,
    duration: 0.7,
    ease: 'power2.inOut',
  })
  emit('goBack')
}

const closeAccordion = () => {
  isAccordionOpen.value = false
  gsap.to(accordionContent.value, {
    height: 0,
    margin: 0,
    duration: 0.7,
    ease: 'power2.inOut',
  })
}

watch(
  () => props.isFullOverlayOpen,
  (newVal) => {
    if (!newVal) {
      closeAccordion()
    }
  },
)

onMounted(() => {
  gsap.set(accordionContent.value, { height: 0, overflow: 'hidden', margin: 0 })
})

defineExpose({ submenuContainer })
</script>

<script>
export default {
  name: 'SubmenuMobile',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
